import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row space-x-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-white text-4xl" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

import { ref } from "vue";
import InputText from "@/components/Form/Common/InputText.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'InputTextWithSubmit',
  props: {
    name: {},
    placeholder: {},
    id: {},
    is_required: { type: Boolean },
    function: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const textValue = ref("");

const onSubmit = () => {
  props.function(textValue.value);
  textValue.value = "";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(InputText, {
      name: props.name,
      placeholder: props.placeholder,
      id: props.id,
      is_required: props.is_required,
      modelValue: textValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((textValue).value = $event))
    }, null, 8, ["name", "placeholder", "id", "is_required", "modelValue"]),
    _createElementVNode("button", {
      class: "h-10",
      type: "button",
      name: "submit",
      onClick: onSubmit
    }, _hoisted_3)
  ]))
}
}

})